import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Sprache der Seite auszeichnen, damit Browser-Übersetzer (z. B. Google Translate) greifen
document.documentElement.lang = "de";
document.documentElement.removeAttribute("translate");
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-411" data-mp="2aavtjnjqsyar" />);
}